//console.log(tgblFields)
/**
 * Handle fields
 *
 */
import { FieldsValidation } from './fields-validation'

const Fields = ($) => {
  if (!window.Tangible) return

  const tangibleSelect = window.Tangible.Select
  const localized = tgblFields.localized

  const validator_active = typeof $.fn.validate !== 'undefined'
  FieldsValidation($)
  const fValidator = window.TangibleFieldsValidation

  const parent= $( 'tangible-fields' )
  const parent_form= parent.parents('form')

  $(document).ready(function () {
    window.FieldsFunctions.constructor()
  })

  window.FieldsFunctions = {

    // initialize the code
    constructor: function () {

      const $_this =this;
      if (parent.length) {
        this.repeaterField(parent,$_this)
        this.select2Init(parent,$_this)
        this.addMedia(parent,$_this)
        this.addDatepicker(parent,$_this)
        this.addColorpicker(parent,$_this)
        this.toggleButton(parent,$_this)

        //if (validator_active) fValidator.checkSettingsRequiredFields(parent,$_this)
      }
    },

    toggleButton: function (parent) {

      parent.on('click','.tgbl-toggle-btn',function() {
        const $this = $(this)
        const state_label_on = $this.attr('data-state-label-on')
        const state_label_off = $this.attr('data-state-label-off')

        if($this.attr('data-state') == 'off') {
          $this.addClass('active').attr('data-state','on')
          $this.find('.tgbl-cb-value-hidden').val('on')
          $this.parents('.tgbl-toggle-btn-wrap').find('.tgbl-data-state-label').html(state_label_on)
        } else {
          $this.removeClass('active').attr('data-state','off')
          $this.find('.tgbl-cb-value-hidden').val('off')
          $this.parents('.tgbl-toggle-btn-wrap').find('.tgbl-data-state-label').html(state_label_off)
        }
      })

    },

    addColorpicker: function (parent) {

      const tgbl_colorpicker = parent.find('.tgbl-colorpicker')
      tgbl_colorpicker.wpColorPicker({
        change: function (event, ui) {
          const element = event.target
          //const color = ui.color.toString()
          //validation
          if (validator_active) {
            setTimeout(function () {
              //$(element).valid()
              fValidator.validateForm(parent_form,fValidator)
              fValidator.validationErrorsNumber(fValidator, parent_form)
            }, 300)
          }
        },
        clear: function (event) {
          const element = $(event.target).parents('.wp-picker-input-wrap').find('.wp-color-picker')
          //validation
          if (validator_active) {
            //element.valid()
            fValidator.validateForm(parent_form,fValidator)
            fValidator.validationErrorsNumber(fValidator, parent_form)
          }
        }
      })

    },


    addDatepicker: function (parent) {

      const tgbl_datepicker = parent.find('.tgbl-datepicker')

      if(tgbl_datepicker.attr('data-options') === undefined ) return
      const options= JSON.parse(tgbl_datepicker.attr('data-options'))

      tgbl_datepicker.datepicker({
        options ,
        onSelect :function(dateText) {
          //validation
          if (validator_active) {
            //$(this).valid()
            fValidator.validateForm(parent_form,fValidator)
            fValidator.validationErrorsNumber(fValidator, parent_form)
          }
        }
      })
    },

    addMedia: function (parent) {

      const tgbl_upload_button = parent.find('.tgbl-field-wrap.field_file .tgbl_upload_file_button')
      const tgbl_remove_button = tgbl_upload_button.parents('.tgbl-field-wrap').find('.tgbl_remove_file_button')
      const field_input = tgbl_upload_button.parents('.tgbl-field-wrap').find('.field_input')

      if(field_input.val()){
        tgbl_upload_button.hide()
        tgbl_remove_button.show().html(localized.remove_file)
      }else{
        tgbl_upload_button.show()
        tgbl_remove_button.hide()
      }

      parent.on('click', '.tgbl_upload_file_button', function(e){
        e.preventDefault()

        const field_input = $(this).parents('.tgbl-field-wrap').find('.field_input')
        const field_input_url = $(this).parents('.tgbl-field-wrap').find('.field_input.url')
        const field_input_id = $(this).parents('.tgbl-field-wrap').find('.field_input.id')
        const tgbl_upload_preview = $(this).parents('.tgbl-field-wrap').find('.tgbl_upload_preview')
        const tgbl_remove_button = $(this).parents('.tgbl-field-wrap').find('.tgbl_remove_file_button')
        const tgbl_upload_button = $(this)

        const tgbl_uploader = wp.media({
          title: localized.add_media_button,
          button: {
            text: localized.media_modal_button
          },
          multiple: false
        }).on('select', function() {
          const attachment = tgbl_uploader.state().get('selection').first().toJSON()
          //console.log(attachment)
          field_input.val(attachment.filename)
          field_input_url.val(attachment.url)
          field_input_id.val(attachment.id)
          tgbl_upload_preview.attr('href',attachment.url).text(attachment.filename)
          tgbl_remove_button.show().html(localized.remove_file)
          tgbl_upload_button.hide()

          //validation
          if (validator_active) {
            //field_input.valid()
            fValidator.validateForm(parent_form,fValidator)
            fValidator.validationErrorsNumber(fValidator, parent_form)
          }
        })
          .open()
      })

      parent.on('click', '.tgbl_remove_file_button', function(e){
        e.preventDefault()
        $(this).parents('.tgbl-field-wrap').find('.field_input').val('')
        $(this).parents('.tgbl-field-wrap').find('.field_input.url').val('')
        $(this).parents('.tgbl-field-wrap').find('.field_input.id').val('')
        $(this).parents('.tgbl-field-wrap').find('.tgbl_upload_preview').attr('href','').text('')

        $(this).hide()
        $(this).parents('.tgbl-field-wrap').find('.tgbl_upload_file_button').show()

        //validation
        if (validator_active) {
          //$(this).parents('.tgbl-field-wrap').find('.field_input').valid()
          fValidator.validateForm(parent_form,fValidator)
          fValidator.validationErrorsNumber(fValidator, parent_form)
        }
      })
    },

    select2Init: function (parent, $_this) {

      // Tags select2
      const s = parent.find('select')

      s.tangibleSelect({
        allowClear: true,
      })

      //validation
      if (validator_active){
        parent.on('change.select2 select2:select select2:clearing select2:unselect', 'select', function (e) {
          //$(this).valid()
          fValidator.validateForm(parent_form,fValidator)
          fValidator.validationErrorsNumber(fValidator,parent_form)
        })
      }

    },

    // @see https://github.com/DubFriend/jquery.repeater
    repeaterField: function (parent,$_this) {
      const s = parent.find('select')
      const nested_repeaters = []

      $('.tgbl-repeater').repeater({

        // Removes the delete button from the first list item.
        isFirstItemUndeletable: true,

        show: function () {
          $(this).slideDown()
          $_this.addColorpicker(parent)
          $(this).find('.tgbl_upload_preview').attr('href','').text('')
          $_this.repeaterResetID($(this),$_this,parent)
        },

        hide: function (deleteElement) {
          $(this).slideUp(deleteElement)
          $_this.repeaterResetID($(this),$_this,parent)
        },

        // Manually re-index
        ready: function (setIndexes) {
          //$dragAndDrop.on('drop', setIndexes);
        },

        // Nested repeater
        repeaters: [{
          // (Required)
          selector: '.tgbl-inner-repeater',
          isFirstItemUndeletable: true,
          initEmpty: false,
          defaultValues: {},

          show: function () {
            $(this).slideDown()
            //$_this.addDatepicker(parent)
            $_this.addColorpicker(parent)
            $(this).find('.tgbl_upload_preview').attr('href','').text('')
            $_this.repeaterResetID($(this),$_this,parent)
          },

          hide: function (deleteElement) {
            $(this).slideUp(deleteElement)
            $_this.repeaterResetID($(this),$_this,parent)
          }
        }],
      })
    },

    repeaterResetID: function (item,$_this,parent) {
      const list = item.parents('.repeater-data-list')

      setTimeout(function() {

        // each repeater
        list.find('.repeater-item').each(function (index) {

          // each repeater field
          $(this).find('.tgbl-outer-repeater-field input, .tgbl-outer-repeater-field select, .tgbl-outer-repeater-field textarea').each(function () {

            const id = $(this).attr('id')
            if(id !== undefined ) {
              const id_a = id.split('__')
              $(this).attr('id', id_a[0] + '__' + index)
            }
          }) // end each repeater field

          // each nested repeater
          $(this).find('.nested-repeater-item').each(function (index_nested) {

            // each nested repeater field
            $(this).find('.tgbl-nested-repeater-field input, .tgbl-nested-repeater-field select, .tgbl-nested-repeater-field textarea').each(function () {

              const id = $(this).attr('id')
              if(id !== undefined ) {
                //console.log('id : ', id ) // repeater_checkbox_group_1__0__0
                const id_a = id.split('__')
                $(this).attr('id', id_a[0] + '__' + index + '__'+ index_nested)
              }
            }) // end each nested repeater field
          }) // end each nested repeater
        }) // end each repeater

        $_this.select2Init(parent)
        $_this.addDatepicker(parent)

      }, 500)
    },
  }
}

export { Fields }
